import { FaStar } from "react-icons/fa6";

export default function TopBadgeIcon({icon}) {
    return (
        <div className={`
            relative p-1 text-12 rounded-full transition-all
            bg-gradient-title  text-white shadow-sm text-center
            w-fit flex items-center justify-center overflow-hidden
          `}>
            {icon ?? <FaStar className="size-2" />}
        </div>
    )
}